// Accordion.styles.js
import styled from 'styled-components';

export const FAQContainer = styled.div`
  max-width: 760px;
  width: 100%;
  margin: 16px auto 48px;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-sizing: border-box;
`;

export const AccordionItem = styled.div`
  background-color: #f3fbf9;
  border-radius: 12px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);
  padding: 16px 20px;
  cursor: pointer;

  @media (max-width: 576px) {
    padding: 14px 16px;
  }
`;

export const QuestionRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

export const QuestionText = styled.p`
  margin: 0;
  font-size: clamp(1rem, 1.4vw + 0.6rem, 1.2rem);
  font-weight: 600;
  line-height: 1.4;
  text-align: left;
`;

export const PlusIcon = styled.span`
  font-size: 1.35rem;
  font-weight: bold;
  flex-shrink: 0;
  line-height: 1;
  transition: transform 0.3s ease;

  ${({ isOpen }) =>
    isOpen &&
    `
    transform: rotate(45deg); // Turns "+" into "x"
  `}
`;

export const Answer = styled.div`
  margin-top: 12px;
  font-size: 16px;
  color: #444;
  line-height: 1.5;
  animation: fadeIn 0.3s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-6px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
